import React from 'react';
import Layout from '../components/Layout';
import AIChatButton from '../components/AIChatButton';

const AboutUs: React.FC = () => {
  const teamMembers = [
    {
      name: 'Prof',
      role: 'Lead Tutor',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/portrait-professional-elegant-businessman__7_-removebg-preview.png',
      description: 'Leading expert in accountancy with over 15 years of teaching experience'
    },
    {
      name: 'Prince Okyere',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Prince_Okyerewith-Background.png',
      description: 'Specialized in CIT courses with practical industry knowledge'
    },
    {
      name: 'Abigail Dadzie',
      role: 'Tutor - Oil and Gas / CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Abigail_dadzie-with-Background.png',
      description: 'Expert in Oil and Gas taxation with extensive CIT experience'
    },
    {
      name: 'Prince Tetteh',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/business-person-futuristic-business-environment__2_-removebg-preview.png',
      description: 'Dedicated CIT tutor with focus on practical applications'
    },
    {
      name: 'Enock Sani',
      role: 'Tutor-CIT',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/portrait-professional-elegant-businessman-removebg-preview.png',
      description: 'Experienced CIT tutor with strong academic background'
    },
    {
      name: 'Thomas Ansah',
      role: 'Tutor-ICAG',
      image: 'https://profstudyhub.com/wp-content/uploads/2024/07/Thomas_-removebg-preview.png',
      description: 'ICAG specialist with proven track record of student success'
    }
  ];

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
        {/* Hero Section */}
        <div className="relative overflow-hidden bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in-up">
              About Profs Training Solutions
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto leading-relaxed animate-fade-in-up animation-delay-200">
              Empowering Ghana's future accountants and tax professionals through excellence, innovation, and unwavering commitment to student success.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up animation-delay-400">
              <a
                href="/signup"
                className="inline-block bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-lg"
              >
                Start Your Journey
              </a>
              <a
                href="/legal"
                className="inline-block border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-all duration-300"
              >
                View Legal Info
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

          {/* Story Section */}
          <div className="text-center mb-20">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                Make learning and teaching more effective with active participation and student collaboration. 
                We believe in creating an environment where every student can thrive and achieve their professional dreams.
              </p>
              <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
                <p className="text-lg text-gray-700 italic">
                  "Our mission is to transform the landscape of professional education in Ghana, 
                  making quality accountancy and taxation training accessible to all who seek excellence."
                </p>
              </div>
            </div>
          </div>

          {/* Statistics Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-3">500</div>
              <div className="text-lg font-semibold text-gray-800 mb-2">Graduates</div>
              <div className="text-gray-600">Successful Students</div>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8 text-center transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-3">95%</div>
              <div className="text-lg font-semibold text-gray-800 mb-2">Success Rate</div>
              <div className="text-gray-600">Pass Rate</div>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8 text-center transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-3">50</div>
              <div className="text-lg font-semibold text-gray-800 mb-2">Excellence</div>
              <div className="text-gray-600">Award Winners</div>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-8 text-center transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-3">15+</div>
              <div className="text-lg font-semibold text-gray-800 mb-2">Years</div>
              <div className="text-gray-600">Experience</div>
            </div>
          </div>

          {/* Mission & Vision Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl shadow-lg p-10 border border-blue-200">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              </div>
              <p className="text-gray-700 leading-relaxed text-lg">
                Empowering individuals in Ghana to excel in the fields of accountancy and taxation by providing comprehensive, 
                industry-focused education. We are dedicated to nurturing a learning environment that fosters critical thinking, 
                ethical practices, and professional proficiency.
              </p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-lg p-10 border border-green-200">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              </div>
              <p className="text-gray-700 leading-relaxed text-lg">
                To be the foremost educational institution in Ghana for accountancy and taxation, recognized for our commitment 
                to excellence, innovation, and the holistic development of individuals who will shape the future of finance in Africa.
              </p>
            </div>
          </div>

          {/* Team Section */}
          <div className="bg-white rounded-2xl shadow-xl p-12 mb-20 border border-gray-100">
            <h3 className="text-4xl font-bold text-gray-900 mb-12 text-center">
              Meet Our Expert Team
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {teamMembers.map((member, index) => (
                <div key={index} className="text-center group">
                  <div className="relative w-40 h-40 mx-auto mb-6">
                    <div className="w-full h-full rounded-full overflow-hidden shadow-lg border-4 border-gray-200 group-hover:border-primary-300 transition-all duration-300">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                        onError={(e) => {
                          const target = e.target as HTMLImageElement;
                          target.src = 'https://via.placeholder.com/160x160/6B7280/FFFFFF?text=' + member.name.charAt(0);
                        }}
                      />
                    </div>
                    <div className="absolute inset-0 rounded-full bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h4>
                  <p className="text-primary-600 font-medium mb-3">{member.role}</p>
                  <p className="text-gray-600 text-sm leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Background Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-xl p-12 text-white mb-20">
            <div className="max-w-4xl mx-auto text-center">
              <h3 className="text-4xl font-bold mb-8">Our Background</h3>
              <p className="text-xl leading-relaxed text-gray-200 mb-8">
                Led by a team of seasoned professors and industry experts, Profs Training Solutions is dedicated to equipping 
                students with the knowledge, skills, and confidence needed to excel in the dynamic world of audit and assurance.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
                <div className="text-center">
                  <div className="text-3xl font-bold text-primary-400 mb-2">2000+</div>
                  <div className="text-gray-300">Successful Students</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-primary-400 mb-2">15+</div>
                  <div className="text-gray-300">Years Experience</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-primary-400 mb-2">95%</div>
                  <div className="text-gray-300">Success Rate</div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl shadow-2xl p-12 text-white">
              <h3 className="text-3xl font-bold mb-6">Ready to Start Your Journey?</h3>
              <p className="text-xl mb-8 text-blue-100">
                Join hundreds of successful students who have transformed their careers with our expert-led programs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="/signup"
                  className="inline-block bg-white text-primary-600 px-10 py-4 rounded-lg font-semibold hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 shadow-lg"
                >
                  Get Started Today
                </a>
                <a
                  href="/catalog"
                  className="inline-block border-2 border-white text-white px-10 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-all duration-300"
                >
                  Browse Courses
                </a>
              </div>
            </div>
          </div>

          {/* AI Chat Button */}
          <AIChatButton />
        </div>
      </div>
    </Layout>
  );
};

export default AboutUs;
